import React from 'react';
import { Link, IndexLink } from 'react-router-dom';
import { connect } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import * as ImageUrl from "../../../constants/constant.js";
import * as constant from "../../../constants/constant.js";
import * as appointmentActions from '../../../actions/appointmentActions.js';
import * as disputeActions from '../../../actions/disputeActions.js';
import * as dashboardActions from "../../../actions/dashboardActions.js";
import ReactLoading from 'react-loading';
import { bindActionCreators } from 'redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Reaptcha from 'reaptcha';
import moment from 'moment';
import '../../../styles/css/dispute.css'
import { Button, Form, FormGroup, Label, Input, Alert } from 'react-bootstrap';
// import DisputeHeader from './disputeHeader.js';
// import DisputeFooter from './disputeFooter.js';
// {constant.PRODUCTION_IMAGE_URL + 'patientImage/' + image}
const size = 10;
let btnSize = { fontSize: '13' };
class DisputeFinance extends React.Component {
    constructor(props, context) {
        super(props);
        this.state = {
            logoutButton: false,
            disputeList: [],
            isLoader: false,
            disputeInput: {
                value: '',
                valid: false,
                message: '',
                isTouched: false
            },
            disputedAppointmentDetails: {},

        };
    }


    componentWillMount() {
        let objectDocument = {
            disputeId: this.props.match.params.disputeId,
        }

        if (objectDocument) {
            // this.props.appointmentactions.getAppointmentDetails(objectDocument)
            this.props.disputeactions.getDisputedAppointmentDetails(objectDocument);
        } else {
            // this.props.history.push('/')
        }

    }
    componentWillReceiveProps(nextProps) {

        // if (nextProps.dispute && nextProps.dispute.listing) {
        //     this.setState({ disputeList: nextProps.dispute.listing.data, isLoader: false })
        // }
        if (nextProps.dispute && nextProps.dispute.disputedAppointmentDetails) {
            this.setState({
                disputedAppointmentDetails: nextProps.dispute.disputedAppointmentDetails,
                disputeInput: {
                    ...this.state.disputeInput,
                    value: nextProps.dispute.disputedAppointmentDetails.resolutionComment,
                    valid: nextProps.dispute.disputedAppointmentDetails.resolutionComment !== '' ? true : false
                }
            })
        }
    }

    inputOnChange = (e) => {
        this.setState({
            disputeInput: {
                ...this.state.disputeInput,
                value: e.target.value,
                isTouched: true,
                valid: true,
            }
        }, () => {
            console.log("this.state", this.state.disputeInput)
            if (this.state.disputeInput.value.length <= 0)
                this.setState({
                    disputeInput: {
                        ...this.state.disputeInput,
                        valid: false,
                        isTouched: false,
                        message: 'Please state the resolutaion for this dispute'
                    }
                });
        });
    }

    submitDisputeForAppointment = (data) => {
        console.log('data:', data.submitResponse == true)
        this.setState({ submitted: true })
        // console.log("this.sssss", this.state.disputeInput)
        if (!this.state.disputeInput.valid && !this.state.disputeInput.isTouched) {
            this.setState({
                disputeInput: {
                    ...this.state.disputeInput,
                    message: 'Please state the Resolution for this dispute'
                }
            })
        } else {
            console.log(this.state.disputeInput.value.length)
            if (this.state.disputeInput.value.length <= 0)
                this.setState({
                    disputeInput: {
                        ...this.state.disputeInput,
                        valid: false,
                        isTouched: false,
                        message: 'Please state the Resolution for this dispute'
                    }
                })
            else {
                let disputeObject = {
                    userDisputeId: this.props.match.params.disputeId,
                    resolutionComment: this.state.disputeInput.value,
                    createdBy: localStorage.getItem('userId'),
                    amount: this.state.disputedAppointmentDetails.fee
                    // appointmentId: this.state.appointmentId,
                    // subDisputeId: this.props.subDisputeDetail._id
                }
                if (data.submitResponse == true) disputeObject.submitResponse = true;
                if (data.closeIssue == true) disputeObject.closeIssue = true;
                if (data.refundToUser == true) disputeObject.refundToUser = true;

                console.log("submitted", disputeObject);
                this.props.disputeactions.markUserDisputeAsResolved(disputeObject, this.props)

            }
        }
    }

    handleRefundAmountInput = (event) => {
        let amount = parseInt(event.target.value);
        this.setState({
            ...this.state,
            disputedAppointmentDetails: {
                ...this.state.disputedAppointmentDetails,
                fee: amount
            }

        })
    }

    render() {
        // var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
        // if (user && user.gender == undefined) {
        //     user = { ...user, gender: 'Male' }
        //     // localStorage.setItem('user', JSON.stringify(user));
        //     // user = JSON.parse(localStorage.getItem("user"));
        // }
        // var gender = localStorage.getItem('user')
        // var defaultImagePath = (user && user.gender) == 'Male' ?
        //     constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" : constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png";
        // var imagePath = ''
        // if (user && user.image == "noUserImage.jpg") {
        //     imagePath = user && user.gender == 'Male' ?
        //         constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" : constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png";
        // } else {
        //     imagePath =
        //         ImageUrl.PRODUCTION_IMAGE_URL +
        //         "uploads/" +
        //         localStorage.getItem("userId") +
        //         "/" +
        //         (user && user.image);
        // }
        let {
            description,
            appointmentStatus,
            checkappointmentDate,
            appointmentTime,
            fee,
            payment,
            pUserName,
            currencySymbol,
            dUserName,
            disputeStatus,
            resolutionComment,
            specialistProfile
        } = this.state.disputedAppointmentDetails ? this.state.disputedAppointmentDetails : {}
        let imagePath = '';
        if (specialistProfile) {
            if (specialistProfile && specialistProfile.doctorProfile[0].profileImage == "") {
                    imagePath = specialistProfile && specialistProfile.doctor[0].gender == 'Male' ?
                        constant.PRODUCTION_IMAGE_URL + "uploads/common/doctor_m.png" : constant.PRODUCTION_IMAGE_URL + "uploads/common/doctor_f.png";
                } else {
                    imagePath =
                        ImageUrl.PRODUCTION_IMAGE_URL +
                        "uploads/" +
                        (specialistProfile && specialistProfile.doctor[0]._id) +
                        "/" +
                        (specialistProfile.doctor[0] && specialistProfile.doctorProfile[0].profileImage);
                }
        }
        console.log("IMAGEPATH==>", imagePath)
        return (
            <div className="wrapper">
                {this.state.isLoader ? <div className="loaderCenter"> <ReactLoading type={'bars'} color={'blue'} /></div> :
                    (<React.Fragment>
                        <div className="user-profile">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-2 offset-md-2">
                                        <div className="profile-image mb-5">
                                            <img src={imagePath} />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="profile-details mb-5">
                                            {/* <h4 className="name">dr. angila richards</h4> */}
                                            <br></br>
                                            <h4 className="infoUser">appointment date: {moment(checkappointmentDate).local().format("DD-MM-YYYY")}</h4>
                                            <br></br>
                                            <h4 className="infoUser">appointment time: {appointmentTime}</h4>
                                            <br></br>
                                            <h4 className="infoUser">patient name: {pUserName}</h4>
                                            <br></br>
                                            <h4 className="infoUser">Specialist Name: Dr. {dUserName}</h4>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="profile-details mb-5">
                                            {/* <h4 className="name">dr. angila richards</h4> */}
                                            <br></br>
                                            <h4 className="infoUser">appointment Status: {appointmentStatus == '1' ?
                                                'Not Compeleted' : appointmentStatus == '2' ? 'Completed' : appointmentStatus == '3'
                                                    ? 'Specialist No Show' : appointmentStatus == '4'
                                                        ? 'Patient No Show' : appointmentStatus == '5'
                                                            ? 'Reserved' : appointmentStatus == '6'
                                                                ? 'Cancel By Specialist' : appointmentStatus == '7'
                                                                    ? 'Cancel By Patient' : ''}</h4>
                                            <br></br>
                                            <h4 className="infoUser">Consulation Fees: {currencySymbol} {fee}</h4>
                                            <br></br>
                                            <h4 className="infoUser">Payment Methods: {payment}</h4>
                                            <br></br>
                                        </div>
                                    </div>
                                    {/* <div className="col-md-4">
                                        <div className="profile-address">
                                            <div className="addressLine d-flex">
                                                <i className="fa fa-home" aria-hidden="true"></i>
                                                <p style={{"marginLeft": "18px"}}>Test Clinic</p>
                                            </div>
                                            <div className="addressLine d-flex">
                                                <i className="fa fa-map-marker" aria-hidden="true"></i>
                                                <p className="address" style={{"marginLeft": "22px"}}> Elmer Gardens, Isleworth, England,United Kingdom, TW76HA</p>
                                            </div>
                                            <div className="addressLine d-flex">
                                                <img src={require('../../../images/fees_icon.png')} alt="" />
                                                <p className="address">Consulation Fees</p>
                                            </div>
                                            <a onClick={this.viewRecipt} style={{"marginLeft": "13px", "cursor": "pointer", "font-size": "17px"}}>View Reciept</a>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>


                        <div className="features">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-8 offset-md-2">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="profile-details mb-5">

                                                    <h4 className="name">Issue Description</h4>

                                                    <div>
                                                        <p>
                                                            {description}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="profile-details mb-5">

                                                    <h4 className="name">Resolution Comments</h4>
                                                    <textarea className="form-control" value={/* resolutionComment !== '' ? resolutionComment : */ this.state.disputeInput.value} /* disabled={resolutionComment == '' ? false : true} */ onChange={this.inputOnChange} rows="5" cols="10" placeholder="Enter resolution comments here"></textarea>
                                                    <div>
                                                        {!this.state.disputeInput.valid && !this.state.disputeInput.isTouched && this.state.submitted && <small className="error"> {this.state.disputeInput.message}</small>}
                                                    </div>
                                                    <div className="form-group">
                                                        <button type="button" /* disabled={disputeStatus == '1'} */ onClick={() => this.submitDisputeForAppointment({ submitResponse: true })} className="btn btn-warning">submit</button>
                                                    </div>
                                                </div>
                                                <div className="loginInput1">
                                                    <div className="row">
                                                        <div className="col-sm-4">
                                                            {/* <div className="boxMrgB boxMrgT"> */}
                                                            <div className="">
                                                                <label htmlFor="dailyAfter"> Amount to be Refunded </label>
                                                            </div>
                                                        </div>
                                                        <label htmlFor="dailyAfter"> {currencySymbol} </label>
                                                        <div className="col-sm-4">
                                                            <div className="input-group inputBg" style={{ color: '#4d4d4d !important' }}>
                                                                {/* <div className="input-group inputBg clock"> */}
                                                                <input style={{ width: '100%', height: '41px' }} name="refundAmount" type="number" value={fee} onChange={this.handleRefundAmountInput} defaultValue={1} />
                                                                {/* </div> */}
                                                            </div>
                                                        </div>
                                                        <button style={{"margin-top": "12px"}} /* disabled={disputeStatus == '1'} */ type="button" onClick={() => this.submitDisputeForAppointment({refundToUser: true})} className="btn btn-warning">Refund </button>

                                                        {/* <div className="col-sm-4" className="occurrenceSpan"><label> Occurrences</label> </div> */}
                                                    </div>
                                                </div>
                                                <div class="btnSubmit text-center" /* style="margin: auto" */><button type="button" class="btn btn-warning" onClick={() => this.submitDisputeForAppointment({closeIssue: true})} disabled={disputeStatus == "1"}>Close Issue</button>&nbsp;
                                                <button class="btn btn-primary">Cancel</button></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </React.Fragment>
                    )}

            </div>
        );
    }
}
//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
    return {
        dispute: state.dispute

        // specialistPatients: state.specialist.specialistPatients
    };
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
    return {
        appointmentactions: bindActionCreators(appointmentActions, dispatch),
        disputeactions: bindActionCreators(disputeActions, dispatch),
        actions: bindActionCreators(dashboardActions, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(DisputeFinance);